import './DropdownHead.scss';

import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FlexBox } from 'ViatoUi/Shared/Layouts/Flex';

const DropdownHead = ({ onClick, active, arrowPosition, className, transparent, closable, label, headerInfo }) => {
	const onClickHandler = e => {
		onClick(e);
	};

	return (
		<FlexBox
			alignItems='center'
			className={cx(
				'react__dd-header',
				{ active },
				arrowPosition === 'left' ? 'react__dd-arrow-left' : 'react__dd-arrow-right',
				className
			)}
			data={{ 'data-transparent': transparent }}
		>
			{closable && (
				// eslint-disable-next-line jsx-a11y/control-has-associated-label
				<span className='react__dd-icon-outer' role='button' tabIndex={0} onClick={e => onClickHandler(e)}>
					<i className='react__dd-icon fal fa-angle-down' />
				</span>
			)}
			<div className='react__dd-label'>
				<div className='react__dd-label-inner' role='button' tabIndex={0} onClick={e => onClickHandler(e)}>
					{label}
				</div>{' '}
				{headerInfo && <span className='react__dd-header-info'>{headerInfo}</span>}
			</div>
		</FlexBox>
	);
};

DropdownHead.propTypes = {
	active: PropTypes.bool,
	transparent: PropTypes.bool,
	closable: PropTypes.bool,
	className: PropTypes.string,
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	headerInfo: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	arrowPosition: PropTypes.oneOf(['left', 'right']),
	onClick: PropTypes.func
};

DropdownHead.defaultProps = {
	active: false,
	transparent: false,
	closable: true,
	label: {},
	arrowPosition: 'left',
	headerInfo: null,
	className: '',
	onClick: () => {}
};

export default DropdownHead;
